import { Outlet } from "react-router"
import { store } from "@/stores/stores"
import { useSnapshot } from "valtio"

interface ProtectedRouteProps {
  children?: React.ReactNode
  redirectPath?: string
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const snap = useSnapshot(store)

  // if (!snap.session?.user || !snap.session?.session) {
  //   return <Navigate to={props.redirectPath || "/auth/login"} replace />
  // }

  // if (!snap.session.workspace) {
  //   return <Navigate to={props.redirectPath || "/workspaces"} replace />
  // }

  return props.children ?? <Outlet />
}
